module.exports = __webpack_public_path__ + "img/upsell-hifi-bg-mobile.55b55dd.jpg";